require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reimaginingtheworkplace.json") })
        }
      }, "path---reimaginingtheworkplace");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reimaginingtheworkplace!./.cache/json/reimaginingtheworkplace.json
// module id = 1190
// module chunks = 231608221292675